import { Component, OnInit } from '@angular/core';
import { REQUEST_TYPES } from 'src/app/core/models/enum.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserRequestService } from 'src/app/core/services/userRequest.service';

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styleUrls: ['./my-requests.component.scss']
})
export class MyRequestsComponent implements OnInit {
  requests = []
  requestTypes = REQUEST_TYPES;
  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private userRequestService: UserRequestService) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    this.getRequestList();
  }

  getRequestList() {
    this.loadingService.setLoading(true);
    this.userRequestService.getUserRequests().subscribe(response => {
      if (response.success) {
        this.requests = response.userRequests;
        this.loadingService.setLoading(false);
      }
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
      console.log('Error --->:', error);
    });
  }

  getRequestType(status: number) {
    if (status === undefined || status === null) {
      return "";
    }
    let value = this.requestTypes.filter(x => x.code === status);

    if (value !== undefined && value !== null) {
      try{
        return value[0].text;
      }
      catch {
        return "";
      }
    }
  }

  deleteUserRequest(id: string) {
    const x = confirm('Destek talebinizi silmek istediğinize emin misiniz?');
    if (x) {
      this.userRequestService.deleteUserRequest(id).subscribe(response => {
        if (response.success) {
          this.getRequestList();
          this.alertService.alert("Başarılı!", "Destek talebi silindi!", "success");
        } else {
          this.alertService.alert("Hata!", "Destek talebi silinemedi!", "error");
        }
      })
    }
  }

}
